<template>
  <div>
    <c-search-box :isShowSearch="false" @enter="getEsfList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            :disabled="true"
            codeGroupCd="ACCIDENT_WAGE_TYPE_CD"
            itemText="codeName"
            itemValue="code"
            name="wageType"
            label="구분"
            v-model="searchParam.wageType"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-field
            name="accidentUserId"
            :disabled="true"
            type="dept_user"
            label="사고자"
            v-model="searchParam.accidentUserId" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-datepicker
            name="currentStartDt"
            :disabled="true"
            type="dept_user"
            label="요양시작일"
            v-model="searchParam.currentStartDt" />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="wageTable"
      title="지급연월/액수 목록"
      :filtering="false"
      :columnSetting="false"
      :isFullScreen="false"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      rowKey="applyMonth"
      :selection="popupParam.type"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getEsfList" />
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'wage-pop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          wageType: 'DISA',
          accidentUserId: '',
          iimAccidentId: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        wageType: null,
        currentStartDt: null,
        accidentUserId: null,
        empNo: null,
        startDt: null,
        endDt: null,
      },
      grid: {
        columns: [
          {
            name: 'applyMonth',
            field: 'applyMonth',
            label: '지급연월',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'wage',
            field: 'wage',
            label: '지급액수(원)',
            align: 'right',
            type: 'cost',
            sortable: true,
            style: 'width:150px',
          },
        ],
        data: [],
        height: '500px'
      },
      editable: true,
      listUrl: '',
      list2Url: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      realList: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.iim.accident.wage.list.url
      this.list2Url = selectConfig.sop.iim.accident.wage.list2.url
      // code setting
      if (this.popupParam.wageType) {
        this.searchParam.wageType = this.popupParam.wageType
      }
      if (this.popupParam.accidentUserId) {
        this.searchParam.accidentUserId = this.popupParam.accidentUserId
      }
      if (this.popupParam.iimAccidentId) {
        this.searchParam.iimAccidentId = this.popupParam.iimAccidentId
      }
      if (this.popupParam.startDt) {
        this.searchParam.currentStartDt = this.popupParam.startDt
        this.searchParam.startDt = this.popupParam.startDt.substring(0, 7) + '-01'
        this.searchParam.endDt = this.$comm.getThisMonth() + '-01'
      }
      // list setting
      this.getEsfList();
    },
    getEsfList() {
      this.grid.data = []
      this.$http.url = this.list2Url;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.realList = _result.data
        this.getList()
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
        this.$_.forEach(this.realList, _item => {
          this.grid.data = this.$_.reject(this.grid.data, {applyMonth: _item.applyMonth, empNo: _item.empNo});
        })
      },);
    },
    /* eslint-disable no-unused-vars */
    select() {
      let selectData = this.$refs['wageTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '선택하세요.', 
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>
